import { Injectable } from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';
import {EditUserRequest, FilterUserRequest} from '@modules/administration/users/interfaces/user.request';

@Injectable()
export class UsersService extends BaseService{
  readonly prefixUrl =  UrlConstant.USER.PREFIX;
  public getList(filter: FilterUserRequest) {
    return this.post(this.prefixUrl + UrlConstant.USER.LIST, filter);
  }
  public verify(userId: number) {
    return this.post(this.prefixUrl + UrlConstant.USER.VERIFY.replace('{userId}', userId + ''));
  }

  public lockOrUnlock(userId: number) {
    return this.post(this.prefixUrl + UrlConstant.USER.LOCK_UNLOCK.replace('{userId}', userId + ''));
  }

  public deleteUser(userId: number) {
    return this.delete(this.prefixUrl + UrlConstant.USER.DELETE.replace('{userId}', userId + ''));
  }

  public getRoleCanSee(userId: number) {
    return this.get(this.prefixUrl + UrlConstant.USER.GET_ROLE_CAN_SEE);
  }

  public add(data: EditUserRequest) {
    return this.post(this.prefixUrl + UrlConstant.USER.ADD, data);
  }

  public edit(data: EditUserRequest) {
    return this.post(this.prefixUrl + UrlConstant.USER.EDIT.replace("{userId}", data.id + ""), data);
  }

  public unOrAssignedWebsite(userId: number, websiteId: number) {
    return this.post(this.prefixUrl + UrlConstant.USER.UN_OR_ASSIGN_SITE.replace("{userId}", userId + "").replace("{websiteId}", websiteId + ""));
  }
}
